export default class GeoLocation
{
    constructor(
        id,
        name,
        latitude,
        longitude
    ) {
        this.id = id;
        this.name = name;
        this.latitude = latitude;
        this.longitude = longitude;
    }
}



// WEBPACK FOOTER //
// ./entities/GeoLocation.js